import { TYPE, type Rect } from "@gaoya/shared";
import { remainingMs, type UiState } from "../../game/state.js";
import { C, drawProgressBar } from "../theme.js";

export function drawAnswerCountdown(ctx: CanvasRenderingContext2D, ui: UiState, r: Rect, now: number): void {
  const armed = ui.deadline > 0;
  const remain = remainingMs(ui, now);
  const turn = Math.max(1, ui.turnMs);
  const t = armed ? remain / turn : 1;
  const critical = armed && remain > 0 && remain <= 3000;
  ctx.textBaseline = "middle";
  ctx.font = `12px ${TYPE.sans}`;
  ctx.fillStyle = C.ink2;
  ctx.textAlign = "left";
  ctx.fillText("作答倒计时", r.x, r.y + 8);
  ctx.textAlign = "right";
  ctx.fillStyle = critical ? C.seal : C.ink;
  ctx.font = `700 ${critical ? 15 : 13}px ${TYPE.sans}`;
  ctx.fillText(armed ? `${(remain / 1000).toFixed(1)} 秒` : "即将开始", r.x + r.w, r.y + 8);
  drawProgressBar(ctx, r.x, r.y + 18, r.w, 8, t, critical);
}

/** @deprecated 一炷香已改为数字倒计时 + 进度条 */
export function drawIncense(ctx: CanvasRenderingContext2D, ui: UiState, r: Rect, now: number): void {
  drawAnswerCountdown(ctx, ui, r, now);
}
